import parseHTML from '../../../utilities/parseHTML';
import titleTransformer from '../post/title';

const wpPageContentTransformer = ( queried ) =>
{
    const { page:considerPost, allPosts } = queried;
    let post;
    if(considerPost)
    {
        post = considerPost;
    }
    else
    {
        post = queried?.post;
    }

    const hasCtaBanner = post?.content?.includes('id="ql-cta-banner-breadcrumbs"');
    const editorial = parseHTML( post?.content, ['learningCenter'], { articleId: `pg${post?.databaseId}`, allPosts }, true );
    const title = ( editorial?.parsedCollection?.h1?.length ) ? null : titleTransformer( {post} );
    return {
        title: hasCtaBanner ? false : title,
        editorial: editorial?.parsed,
        hasCtaBanner,
    }
}
export default wpPageContentTransformer;
